export default "__VITE_ASSET__DNwmWfzW__"